module.exports = __webpack_public_path__ + "static/background-18ba1465ec0d140e599318f96080fb8e.jpg";